import request from '@/config/axios'

export interface MarketBoardVO {
  id?: number
  code?: string
  title?: string
  boardType?: string
  refKey?: number
  boardSort?: number
  limitCount?: number
  status?: number
}

export const getMarketBoardList = () => request.get({ url: '/market/board/list' })
export const createMarketBoard = (data: MarketBoardVO) =>
  request.post({ url: '/market/board/create', data })
export const updateMarketBoard = (data: MarketBoardVO) =>
  request.put({ url: '/market/board/update', data })
export const deleteMarketBoard = (id: number) =>
  request.delete({ url: '/market/board/delete', params: { id } })
export const updateMarketBoardStatus = (id: number, status: number) =>
  request.put({ url: '/market/board/update-status', params: { id, status } })
